// import Vue from 'vue';
// import Utility from '@/vue/utility/utility';
import BaseModule from '../_base_module';

// initial state
// shape: [{ id, quantity }]
const state = {
  ...BaseModule.state,

  data: [
    // {
    //   type: 'error',
    //   message: 'blahblah'
    // }
  ],
};

// getters
const getters = {
  ...BaseModule.getters,
  all(state, getters, rootState, rootGetters) {
    return state.data;
  }
};

// actions
const actions = {
  ...BaseModule.actions,
  addDangerNotification ({state, commit, dispatch, getters, rootState}, payload) {
      payload.cssClass = 'bg-danger'; // error
      payload.closeButtonColor = 'white'; // error
      payload.position = 'bottom'; // error
      commit('add_notification', payload);
  },
  addWarningNotification ({state, commit, dispatch, getters, rootState}, payload) {
      payload.cssClass = 'bg-warning'; // warning
      payload.closeButtonColor = 'white'; // error
      payload.position = 'bottom'; // warning
      commit('add_notification', payload);
  },
  addInfoNotification ({state, commit, dispatch, getters, rootState}, payload) {
      payload.cssClass = 'bg-info'; // warning
      payload.closeButtonColor = 'white'; // error
      payload.position = 'bottom'; // warning
      commit('add_notification', payload);
  },
  addSuccessNotification ({state, commit, dispatch, getters, rootState}, payload) {
      payload.cssClass = 'bg-success text-dark'; // success
      payload.closeButtonColor = 'black'; // error
      payload.position = 'bottom'; // success
      commit('add_notification', payload);
  },
  addCenterNotification ({state, commit, dispatch, getters, rootState}, payload) {
      payload.cssClass = ''; // success
      payload.position = 'center'; // success
      if(typeof payload.icon !== 'undefined') {
        payload.icon = '<i class="f7-icons">' + payload.icon + '</i>';
      }
      commit('add_notification', payload);
  }
};

// mutations
const mutations = {
  ...BaseModule.mutations,
  add_notification (state, notification) {
    // Werkt met deze:
    // let toast = f7.toast.create({
    //   icon: new_notification.icon,
    //   text: new_notification.message,
    //   cssClass: new_notification.type,
    //   closeButton: true,
    //   destroyOnClose: true,
    //   position: new_notification.position,
    // }).open();

    if(typeof notification.hide_after === 'undefined') {
      notification.hide_after = 4000;
    }
    if(typeof notification.closeButton === 'undefined') {
      notification.closeButton = true;
    }

    let notifications = state.data;
    // Push it to the front so the newest notification is always the first
    notifications.unshift(notification);

    state = { ...state, data: notifications }

    // Vue.set(state, 'data', notifications);
  },
};

export default {

  namespaced: true,

  state,
  getters,
  actions,
  mutations
}
